export const TEMPLATE_OPTIONS = { location: "location", itemType: "itemType", status: "status" };
export const FILTER_TYPE = {
  checkboxes: "checkboxes",
  dateRange: "dateRange",
  searchDropdown: "searchDropdown"
};
